import { useRef, useState } from 'react';
import { Container, LoadSpin } from './styled';
import { Avatar } from '../../../../../components';
import { BsPlayFill, BsPauseFill, BsFillMicFill } from 'react-icons/bs';
import { MdOutlineDownloading } from 'react-icons/md';


export function PlayerAudio(props) {


    const { src, isUserSystem, nameAvatar, date } = props;


    const refAudio = useRef(null);
    const refAudioCurrentTime = useRef(null);
    const refAudioProgress = useRef(null);

    const [duration, setDuration] = useState(0);
    const [isReproduced, setIsReproduced] = useState(false);
    const [playbackRate, setPlaybackRate] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    let isDragging = false;

    const onLoaded = (e) => {
        setDuration(e.target.duration)
    }

    const handlePlay = () => {
        setIsReproduced(true);
        if (refAudio.current) {
            refAudio.current.play();
            refAudio.current.ontimeupdate = () => {
                const currentTime = refAudio.current.currentTime
                refAudioCurrentTime.current.textContent = onFormatTime(currentTime)
                const progressPercent = (currentTime / refAudio.current.duration) * 100;
                refAudioProgress.current.value = progressPercent;
            }
            refAudio.current.onended = () => {
                refAudioCurrentTime.current.textContent = "00:00";
                refAudioProgress.current.value = 0;
                setIsReproduced(false);
            }
        }
    };
    const handlePause = () => {
        setIsReproduced(false);
        if (refAudio.current) {
            refAudio.current.pause();
        }
    };
    const handlePlaybackRate = () => {
        if (playbackRate === 2) {
            setPlaybackRate(1);
            refAudio.current.playbackRate = 1;
            return;
        }
        const rate = playbackRate + 0.5;
        setPlaybackRate(rate);
        refAudio.current.playbackRate = rate;
    };
    const onFormatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60);

        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    };


    const handleMouseDown = (event) => {
        isDragging = true;
        updateProgressBar(event);
    };

    const handleMouseMove = (event) => {
        if (isDragging) {
            updateProgressBar(event);
        }
    };

    const handleMouseUp = () => {
        isDragging = false;
    };

    const updateProgressBar = (event) => {
        const progressBar = event.target;
        const rect = progressBar.getBoundingClientRect();
        const progressWidth = event.clientX - rect.left;
        const progressBarWidth = rect.right - rect.left;
        const seekTime = (progressWidth / progressBarWidth) * refAudio.current.duration;
        refAudio.current.currentTime = seekTime;
    };

    function handleDownload() {
        setIsLoading(true);
        function download(url, filename) {
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                    setIsLoading(false);
                })
                .catch(console.error, setIsLoading(false));
        }
        download(src, `${date}`)
    };


    return (
        <Container>
            <audio
                ref={refAudio}
                src={src}
                controls={false}
                onLoadedMetadata={(e) => {
                    onLoaded(e)
                }}
            ></audio>
            <div className='line--'>
                {isUserSystem &&
                    <>
                        {!isReproduced
                            ? <span className='avatar'>
                                <Avatar name={nameAvatar} width={'100%'} height={'100%'} fontSize={'1.5rem'} />
                                <BsFillMicFill className='mic-icon' />
                            </span>
                            : <div className='playbackRate' onClick={() => handlePlaybackRate()}>
                                <span className="color--UserSystem">
                                    {`${playbackRate}x`}
                                </span>
                            </div>
                        }
                    </>
                }
                {!isReproduced
                    ? <BsPlayFill className='icon--' onClick={() => handlePlay()} />
                    : <BsPauseFill className='icon--' onClick={() => handlePause()} />
                }
                <div className='progress--time'>
                    <span className='downloading'>
                        {!isLoading
                            ? <MdOutlineDownloading onClick={() => handleDownload()} />
                            : <LoadSpin />
                        }
                    </span>
                    <progress
                        ref={refAudioProgress}
                        className='progress--'
                        value="0"
                        max="100"
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                    />
                    <div className='time--'>
                        <span ref={refAudioCurrentTime}>
                            00:00
                        </span>
                        <span>
                            {onFormatTime(duration)}
                        </span>
                    </div>
                </div>
                {!isUserSystem &&
                    <>
                        {!isReproduced
                            ? <span className='avatar'>
                                <Avatar name={nameAvatar} width={'100%'} height={'100%'} fontSize={'1.5rem'} />
                                <BsFillMicFill className='mic-icon' />
                            </span>
                            : <div className='playbackRate' onClick={() => handlePlaybackRate()}>
                                <span>
                                    {`${playbackRate}x`}
                                </span>
                            </div>
                        }
                    </>
                }
            </div>
        </Container>
    )
}